const apiUrl = process.env.REACT_APP_API_URL;

// ✅ Register or login user
export const registerOrLogin = async (username, password) => {
  try {
    console.log("Sending request to login or register user...");
    
    const response = await fetch(`${apiUrl}/registerOrLogin`, { 
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
    });

    // ✅ Handle errors if the request fails
    if (!response.ok) {
      const errorData = await response.json();
      console.error("Registration/Login error:", errorData);
      
      // ✅ Return specific error message
      return { success: false, message: errorData.message };
    }

    const data = await response.json();

    // ✅ Ensure the response includes a `user_id`
    if (!data.user_id) {
      console.error("Missing user_id in response:", data);
      return { success: false, message: "User ID is missing in the response." };
    }

    console.log("Registration/Login success:", data);
    return { success: true, user_id: data.user_id }; // ✅ Return user_id
  } catch (error) {
    console.error("Unexpected error occurred during login/registration:", error.message);
    return { success: false, message: "An unexpected error occurred." };
  }
};
